
export const options = [
    { label: "Personal Files", value: "Personal Files" },
    { label: "Contract Files", value: "Contract Files" },
    { label: "Mandate Files", value: "Mandate Files" },
    { label: "Insurance Files", value: "Insurance Files" },
]